import * as types from '../constants/officeRunnerConstants'

export default function selectedPosition(state = null, action) {
  switch (action.type) {
    case types.FETCH_POSITION_FAILURE:
      return null
    case types.FETCH_POSITION_SUCCESS:
    case types.SELECT_POSITION:
      return action.position || null
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/selectedPositionReducer.js